import "./Navbar.css";
import { useState } from "react";
import { HashLink } from "react-router-hash-link";
import logo from "../assets/Polygon.svg";

const Navbar = () => {
  const [active, setActive] = useState(false);

  return (
    <div className="navbar fixed w-full flex justify-between items-center py-4 px-12 z-40 bg-black/90 backdrop-blur">
      <div className="logo-container">
        <HashLink to="#home" className="logo-link" smooth>
          <div className="logo-wrapper">
            <img src={logo} alt="Logo" className="logo-img" />
            <span className="logo-text glowText">V</span>
          </div>
        </HashLink>
      </div>

      <div className="menu-toggle md:hidden" onClick={() => setActive(!active)}>
        <div className={`hamburger ${active ? "active" : ""}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <nav className={`nav-menu ${active ? "active" : ""}`}>
        <div className="nav-content">
          <ul className="nav-list">
            <li>
              <HashLink
                to="#about"
                className="nav-link glowText"
                onClick={() => setActive(false)}
                smooth
              >
                About
              </HashLink>
            </li>
            <li>
              <HashLink
                to="#experience"
                className="nav-link glowText"
                onClick={() => setActive(false)}
                smooth
              >
                Experience
              </HashLink>
            </li>
            <li>
              <HashLink
                to="#work"
                className="nav-link glowText"
                onClick={() => setActive(false)}
                smooth
              >
                Work
              </HashLink>
            </li>
            <li>
              <HashLink
                to="#contact"
                className="nav-link glowText"
                onClick={() => setActive(false)}
                smooth
              >
                Contact
              </HashLink>
            </li>
          </ul>
          <a
            href={process.env.PUBLIC_URL + "/VikasPawar.pdf"}
            className="resume-btn glowText"
            download="VikasPawar"
            onClick={() => setActive(false)}
          >
            Resume
          </a>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
